import { Gift, Mail, ArrowUpRight } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "./motion";

// Mesa de regalos compartida (sección opcional, pensada para bautismos y
// quinceañeras; cualquier plantilla puede sumarla). Contrato:
//
// regalos: {
//   mensaje: string,                          // p. ej. "Tu presencia es el mejor regalo…"
//   tiendas: [{ nombre, url, nota? }],        // mesas de regalos con enlace
//   alternativa?: { titulo, texto },          // p. ej. lluvia de sobres
// }
//
// Como toda sección del núcleo: sin datos no se renderiza (sin huecos) y el
// prefijo `p` deja la estética en manos de cada plantilla.
export default function Regalos({ datos, seccion, p = "we" }) {
  const regalos = datos.regalos;
  if (!regalos) return null;
  const tiendas = (regalos.tiendas || []).filter((t) => t?.nombre);
  if (!regalos.mensaje && tiendas.length === 0 && !regalos.alternativa) return null;

  return (
    <section className={`${p}-seccion ${p}-regalos`} aria-label={seccion.titulo}>
      <div className={`${p}-seccion-interior`}>
        <EncabezadoSeccion p={p} etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid={`${p}-titulo-regalos`} />
        <Reveal>
          {regalos.mensaje && (
            <p className={`${p}-regalos-mensaje`}>
              <Gift strokeWidth={1.5} aria-hidden="true" />
              {regalos.mensaje}
            </p>
          )}
          {tiendas.length > 0 && (
            <div className={`${p}-regalos-tiendas`}>
              {tiendas.map((tienda, i) => (
                <a
                  key={i}
                  className={`${p}-regalo-tienda`}
                  href={tienda.url || "#"}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`${p}-regalo-tienda-${i}`}
                >
                  <span className={`${p}-regalo-tienda-nombre`}>
                    {tienda.nombre}
                    <ArrowUpRight strokeWidth={1.5} aria-hidden="true" />
                  </span>
                  {tienda.nota && <span className={`${p}-regalo-tienda-nota`}>{tienda.nota}</span>}
                </a>
              ))}
            </div>
          )}
          {regalos.alternativa?.titulo && (
            <p className={`${p}-regalo-alternativa`} data-testid={`${p}-regalo-alternativa`}>
              <Mail strokeWidth={1.5} aria-hidden="true" />
              <span>
                <strong>{regalos.alternativa.titulo}</strong>
                {regalos.alternativa.texto ? ` — ${regalos.alternativa.texto}` : ""}
              </span>
            </p>
          )}
        </Reveal>
      </div>
    </section>
  );
}
